var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHPattern1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110.528px",
    height: "30px",
    viewBox: "0 0 110.528 30",
    enableBackground: "new 0 0 110.528 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-150.741,5.104c0.8,0.961,2.136,1.61,3.226,2.149c4.045,1.997,8.582,3.005,13.001,3.747 c9.248,1.551,18.71,1.795,28.068,1.625c16.206-0.295,32.378-1.996,48.422-4.219C-38.028,5.634-18.06,3.22,2.16,3.188 c0.526,0,0.527-0.818,0-0.818c-16.897,0.026-33.765,1.542-50.496,3.836c-17.319,2.376-34.608,4.722-52.095,5.423 c-10.266,0.412-20.648,0.403-30.85-0.964c-5.006-0.671-10.161-1.618-14.817-3.653c-1.359-0.594-3.099-1.326-4.064-2.486 C-150.5,4.121-151.076,4.702-150.741,5.104L-150.741,5.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M108.914,3.188c17.617,0.027,35.209,1.663,52.641,4.138c17.009,2.415,34.057,4.558,51.241,5.17 c10.08,0.359,20.265,0.289,30.273-1.111c4.934-0.69,9.974-1.665,14.556-3.689c1.392-0.615,3.166-1.379,4.175-2.591 c0.333-0.402-0.242-0.983-0.579-0.578c-0.773,0.929-2.074,1.541-3.15,2.066c-4.069,1.986-8.653,2.958-13.089,3.683 c-9.452,1.543-19.125,1.726-28.679,1.506c-16.649-0.38-33.261-2.194-49.736-4.551c-19.119-2.734-38.314-4.829-57.652-4.859 C108.388,2.37,108.387,3.188,108.914,3.188L108.914,3.188z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M108.914,2.779C68.235,2.788,55.529,27.663,55.529,27.663S42.823,2.788,2.16,2.779 c40.678,0.009,53.37,9.482,53.37,9.482S68.221,2.788,108.914,2.779z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M108.914,2.37c-19.031,0.07-39.742,5.978-51.62,21.855c-0.766,1.023-1.532,2.089-2.118,3.23 c0.235,0,0.471,0,0.706,0c-1.667-3.243-4.322-6.139-6.925-8.635c-6.635-6.365-14.962-10.77-23.749-13.35 C17.73,3.276,9.938,2.399,2.16,2.37c0,0.272,0,0.545,0,0.818c11.905,0.021,23.926,0.703,35.597,3.186 c5.316,1.131,10.754,2.578,15.607,5.09c0.667,0.346,1.354,0.701,1.96,1.15c0.105,0.078,0.307,0.078,0.413,0 c1.926-1.429,4.366-2.332,6.586-3.153c7.634-2.819,15.794-4.228,23.854-5.119c7.549-0.834,15.146-1.142,22.738-1.155 C109.438,3.188,109.44,2.37,108.914,2.37c-11.981,0.021-24.08,0.716-35.826,3.215c-5.348,1.138-10.79,2.608-15.681,5.11 c-0.675,0.344-1.354,0.918-2.051,1.189c0.271-0.105,0.497,0.153,0.141-0.14c-0.296-0.244-0.682-0.422-1.014-0.608 c-4.185-2.341-8.939-3.748-13.568-4.88C28.284,3.167,15.118,2.393,2.16,2.37c-0.526,0-0.527,0.816,0,0.818 c18.772,0.07,39.425,5.885,51.063,21.671c0.705,0.956,1.409,1.949,1.954,3.01c0.137,0.267,0.569,0.267,0.706,0 c1.594-3.104,4.109-5.86,6.587-8.267C68.975,13.288,77.171,8.91,85.824,6.334c7.489-2.229,15.291-3.117,23.09-3.146 C109.438,3.187,109.44,2.369,108.914,2.37z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M82.339,16.189c0,0,12.045,3.428,11.859,13.711l3.707-4.51C97.905,25.391,97.117,18.264,82.339,16.189z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M97.905,4.903l-3.707-4.51c0.186,10.284-11.859,13.712-11.859,13.712 C97.117,12.03,97.905,4.903,97.905,4.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M104.294,12.166l-1.314,0.265c-6.54,1.316-13.183,2.054-19.852,2.209l-21.925,0.506l21.923,0.508 c6.669,0.153,13.31,0.892,19.849,2.208l1.319,0.267l6.234-2.982L104.294,12.166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M28.19,16.189c0,0-12.044,3.428-11.859,13.711l-3.707-4.51C12.624,25.391,13.413,18.264,28.19,16.189z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M12.624,4.903l3.707-4.51C16.146,10.676,28.19,14.104,28.19,14.104 C13.413,12.03,12.624,4.903,12.624,4.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A99575",
    d: "M6.235,12.166l1.314,0.265c6.541,1.316,13.184,2.054,19.851,2.209l21.924,0.506l-21.923,0.508 c-6.668,0.153-13.309,0.892-19.848,2.208l-1.319,0.267L0,15.146L6.235,12.166z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -188.997,
    y: 14.121,
    fill: "#1A1A1A",
    width: 490.589,
    height: 1.801
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M59.713,8.335l-3.415-5.227l-3.416,5.227c-0.72,1.102-0.581,2.575,0.332,3.514l3.084,3.172l3.083-3.172 C60.295,10.91,60.434,9.438,59.713,8.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M52.882,21.707l3.416,5.227l3.415-5.227c0.721-1.103,0.582-2.574-0.332-3.514l-3.083-3.172l-3.084,3.172 C52.301,19.133,52.162,20.604,52.882,21.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M43.983,9.369l-4.874,5.014l-2.531-2.613c-0.579-0.598-1.392-0.521-1.905,0.178 c-0.931,1.27-0.039,3.074,1.521,3.074c-1.56,0-2.452,1.805-1.521,3.074l0,0c0.513,0.699,1.326,0.775,1.905,0.178l2.531-2.613 l4.874,5.014c1.25,1.285,3.231,1.426,4.64,0.327l7.675-5.979l-7.675-5.98C47.214,7.943,45.233,8.083,43.983,9.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M76.414,15.021c1.67,0,2.514-2.043,1.343-3.252c-0.579-0.598-1.392-0.521-1.905,0.178l-2.035,2.775 l-5.204-5.354c-1.25-1.286-3.231-1.426-4.64-0.328l-7.675,5.98l7.675,5.979c1.408,1.099,3.39,0.958,4.64-0.327l5.204-5.354 l2.035,2.775c0.514,0.699,1.326,0.775,1.905,0.178C78.928,17.064,78.084,15.021,76.414,15.021z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M120.828,11.74l-1.676-2.564l-1.676,2.564c-0.353,0.541-0.285,1.264,0.164,1.725l1.512,1.557l1.514-1.557 C121.113,13.004,121.182,12.281,120.828,11.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M117.477,18.302l1.676,2.565l1.676-2.565c0.354-0.541,0.285-1.263-0.162-1.724l-1.514-1.557l-1.512,1.557 C117.191,17.039,117.124,17.761,117.477,18.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M125.195,12.248c-0.613-0.631-1.585-0.699-2.276-0.16l-3.767,2.934l3.767,2.934 c0.691,0.539,1.663,0.471,2.276-0.16l2.696-2.773L125.195,12.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M113.11,12.248l-2.696,2.773l2.696,2.773c0.613,0.631,1.585,0.699,2.276,0.16l3.766-2.934l-3.766-2.934 C114.695,11.549,113.724,11.617,113.11,12.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-4.882,11.74l-1.676-2.564l-1.676,2.564c-0.354,0.541-0.285,1.264,0.163,1.725l1.513,1.557l1.513-1.557 C-4.597,13.004-4.528,12.281-4.882,11.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-8.233,18.302l1.676,2.565l1.676-2.565c0.354-0.541,0.285-1.263-0.163-1.724l-1.513-1.557l-1.513,1.557 C-8.519,17.039-8.587,17.761-8.233,18.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-2.792,12.088l-3.766,2.934l3.766,2.934c0.691,0.539,1.664,0.471,2.277-0.16l2.696-2.773l-2.696-2.773 C-1.128,11.617-2.101,11.549-2.792,12.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-12.6,12.248l-2.696,2.773l2.696,2.773c0.613,0.631,1.585,0.699,2.277,0.16l3.766-2.934l-3.766-2.934 C-11.015,11.549-11.987,11.617-12.6,12.248z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M299.526,15.037l4.827-6.581c1.1-1.497,2.84-1.66,4.078-0.381l0,0c2.506,2.587,0.7,6.962-2.875,6.962 H299.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M299.526,15.037l4.827,6.58c1.1,1.496,2.84,1.66,4.078,0.381l0,0c2.506-2.588,0.7-6.961-2.875-6.961 H299.526z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-182.681,15.037l-4.828-6.581c-1.099-1.497-2.839-1.66-4.078-0.381l0,0 c-2.506,2.587-0.7,6.962,2.875,6.962H-182.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-182.681,15.037l-4.828,6.58c-1.099,1.496-2.839,1.66-4.078,0.381l0,0 c-2.506-2.588-0.7-6.961,2.875-6.961H-182.681z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M192.28,10.337l1.141,1.388c0,0-0.242,2.193-4.792,2.832C188.629,14.558,192.337,13.502,192.28,10.337 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M192.28,19.421l1.141-1.389c0,0-0.242-2.194-4.792-2.833C188.629,15.199,192.337,16.255,192.28,19.421 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "197.307,14.879 195.388,13.961 190.825,14.879 195.388,15.796  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M47.451,27.975l-2.137-0.21c0,0-1.649-2.059,1.655-6.442C46.97,21.322,44.729,25.348,47.451,27.975z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M39.775,20.297l0.209,2.139c0,0,2.06,1.648,6.443-1.655C46.428,20.78,42.402,23.021,39.775,20.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "39.365,28.385 41.763,27.537 44.843,22.906 40.212,25.987  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M43.897,24.266l-0.401-0.402c5.978-5.977,13.925-9.269,22.378-9.269h127.75v0.568H65.874 C57.573,15.163,49.768,18.396,43.897,24.266z"
  }))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-84.084,19.3l-1.141-1.389c0,0,0.243-2.193,4.792-2.832C-80.434,15.079-84.142,16.134-84.084,19.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M-84.084,10.216l-1.141,1.388c0,0,0.243,2.194,4.792,2.833 C-80.434,14.438-84.142,13.382-84.084,10.216z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "-89.111,14.758 -87.192,15.676 -82.63,14.758 -87.192,13.84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M60.744,1.663l2.138,0.209c0,0,1.648,2.059-1.657,6.443C61.225,8.315,63.467,4.29,60.744,1.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M68.42,9.339l-0.209-2.138c0,0-2.059-1.649-6.443,1.656C61.768,8.857,65.793,6.615,68.42,9.339z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "68.829,1.252 66.434,2.099 63.354,6.729 67.983,3.649  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M42.321,15.042h-127.75v-0.568h127.75c8.301,0,16.106-3.232,21.977-9.103l0.401,0.401 C58.722,11.75,50.773,15.042,42.321,15.042z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHPattern1);
export default __webpack_public_path__ + "static/media/h-pattern-1.8d1da45de55f31b68c73bbd8920d0f01.svg";
export { ForwardRef as ReactComponent };